import * as React from "react";
import { cn } from "@fmc-digital/ui";

export function FeedbackIcon({
  className,
  ...props
}: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      fill="none"
      aria-hidden="true"
      className={cn("size-20 shrink-0", className)}
      {...props}
    >
      <path
        d="M66.666 6.66699H13.3327C9.66602 6.66699 6.69935 9.66699 6.69935 13.3337L6.66602 73.3337L19.9993 60.0003H66.666C70.3327 60.0003 73.3327 57.0003 73.3327 53.3337V13.3337C73.3327 9.66699 70.3327 6.66699 66.666 6.66699ZM66.666 53.3337H17.2327L13.3327 57.2337V13.3337H66.666V53.3337ZM36.666 40.0003H43.3327V46.667H36.666V40.0003ZM36.666 20.0003H43.3327V33.3337H36.666V20.0003Z"
        fill="#35CCBA"
      />
    </svg>
  );
}
